/** Function to replace all "shortcut" slashes in module code, after the code is converted to a string */
export const replaceModuleCodeSlashes = (code: string) =>
  code
    .replaceAll("\\", "\\\\")
    .replaceAll("\\\\\\\\", "\\\\")
    .replaceAll("\\\\'", "\\'")
    .replaceAll('\\\\"', '\\"');
